import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import NachReconciliationModalUI from './NachReconciliationModalUI'

class NachReconciliationModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,

      // form events
      submitted: false,
      // form field
      bankStatementTransactionId: '',
      bankStatementTransactionIdError: null,
    }
  }

  render() {
    return (
      <NachReconciliationModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        nachReconciliationMode={this.props.nachReconciliationMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.onCancelClick}
        // form fields
        bankStatementTransactionId={this.state.bankStatementTransactionId}
        onbankStatementTransactionIdChange={(event) => this.setState({ bankStatementTransactionId: event.target.value })}
        bankStatementTransactionIdError={this.state.bankStatementTransactionIdError}
        setbankStatementTransactionIdError={(error) => { this.setState({ bankStatementTransactionIdError: error }) }}
      />
    )
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    let escrowTxnIdList = []

    if (this.props.selectedBankTxnId !== this.state.bankStatementTransactionId) {
      this.setState({ errorList: ['TransactionId did not match'], submitted: false })
    }
    else {
      RestApiUtils.put(this.props.context,
        `/api/su/nach/bankTransactions/${this.state.bankStatementTransactionId}/reconcile`,
        this.onSubmitCallback, {
        transactionList: escrowTxnIdList,
      }
      )
    }
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.onCancelClick()
        this.props.onRefreshClick()
      }, 2000)
    }
  }

  onCancelClick = () => {
    this.setState({
      bankStatementTransactionId: '',
      successMsg: null,
      errorList: [],
      submitted: false
    })
    this.props.onCancelNachReconciliation()
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default NachReconciliationModalSF
